import 'reflect-metadata';
import {
    ArrayNotEmpty,
    IsArray,
    IsBoolean,
    IsEmail,
    IsEnum,
    IsInt,
    IsNotEmpty,
    IsOptional,
    IsString,
    ValidateNested
} from 'class-validator';

import { Type } from 'class-transformer';

export class UserDto {
    id!: number;

    @IsString()
    createdAt!: string;

    @IsString()
    @IsOptional()
    updatedAt?: string;

    @IsEmail()
    @IsNotEmpty()
    email!: string;

    @IsString()
    @IsOptional()
    firstName?: string;

    @IsString()
    @IsOptional()
    name?: string;

    @IsString()
    @IsOptional()
    lastName?: string;

    @IsString()
    @IsOptional()
    phone?: string;

    @IsOptional()
    photo?: string | null;

    @IsBoolean()
    isActive!: boolean;

    @IsNotEmpty()
    userRoles!: UserRole[];

    @IsNotEmpty()
    roleId!: number;

    @IsOptional()
    createdBy?: number | null;

    @IsOptional()
    isDeleted?: boolean;

    @IsOptional()
    subLocations?: any;
    specificationId: any;
    macAddress: any;
    locationId: any;

    @IsOptional()
    userId?: number;

    @IsOptional()
    roleIds?: number;
}

export class DeleteUserDto {
    userId!: string;
}

export class UpdateUserDto {
    @IsEmail()
    @IsOptional()
    email?: string;

    @IsString()
    @IsOptional()
    firstName?: string;

    @IsString()
    @IsOptional()
    lastName?: string;

    @IsString()
    @IsOptional()
    photo?: string;

    @IsBoolean()
    @IsOptional()
    isActive?: boolean;

    @IsOptional()
    // Add specific validation for metadata if needed, for now assuming it can be any type or null
    metadata?: any;

    @IsString()
    @IsOptional()
    password?: string;
}

export class RegisterUserDto {
    @IsString()
    @IsNotEmpty()
    email!: string;

    @IsString()
    @IsNotEmpty()
    firstName!: string;

    @IsString()
    @IsNotEmpty()
    lastName!: string;

    @IsString()
    @IsOptional()
    password?: string;

    @IsArray()
    @ArrayNotEmpty()
    roleIds!: number[];

    @IsString()
    @IsOptional()
    photo?: string;

    @IsOptional()
    metadata?: any;
}

export class RegisterEndUserDto extends RegisterUserDto {
    @IsString()
    @IsNotEmpty()
    override password!: string;
}

export class UserLoginDto {
    @IsEmail()
    @IsNotEmpty()
    email!: string;

    @IsString()
    @IsNotEmpty()
    password!: string;
}

export class UserImageUpdateRequestDto {
    image: any; // Express.Multer.File;
}

export class UserRole {
    @IsInt()
    id!: number;

    @IsString()
    name!: string;
}

export class RegistrationResponse {
    @IsBoolean()
    isActive!: boolean;

    @IsOptional()
    @IsString()
    refreshTokenHashed?: string;

    @IsOptional()
    @IsString()
    deletedAt?: string;

    @IsOptional()
    @IsString()
    deletedBy?: string;

    @IsBoolean()
    isDeleted!: boolean;

    @ValidateNested({ each: true })
    @Type(() => UserRole)
    userRoles!: UserRole[];

    @IsInt()
    id!: number;

    @IsEmail()
    email!: string;

    @IsString()
    firstName!: string;

    @IsString()
    lastName!: string;

    @IsOptional()
    @IsString()
    photo?: string;

    @IsOptional()
    metadata?: any;

    @IsString()
    createdAt!: string;

    @IsOptional()
    @IsString()
    createdBy?: string;

    @IsString()
    updatedAt!: string;

    @IsOptional()
    @IsString()
    updatedBy?: string;
}

export class InvitedUserSignupDto extends RegisterUserDto {
    @IsString()
    @IsOptional()
    invitedByEmail?: string;

    @IsInt()
    @IsOptional()
    locationIdToBeInvited?: number;
}
